import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Modal, Button } from "react-bootstrap";
import StethoscopeLoading from "../../../components/StethoscopeLoading/StethoscopeLoading";
// import axios from "axios"; // Remove if not usedimageContent

const ChatReportPreview = ({ rowData, onClose, fileContent, imageContent }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [iframeLoaded, setIframeLoaded] = useState(false);

  useEffect(() => {
    // Reset states when content changes
    setIsLoading(true);
    setError(null);
    setIframeLoaded(false);
  }, [fileContent, imageContent]);

  const handleIframeLoad = () => {
    setIframeLoaded(true);
    setIsLoading(false);
  };

  const handleIframeError = (error) => {
    console.error('Error loading iframe content:', error);
    setError('Failed to load the document. Please try again.');
    setIsLoading(false);
  };

  return (
    <Modal
      show={true}
      onHide={onClose}
      size="lg"
      centered
      backdrop="static"
      dialogClassName="receipts-modal-size"
      keyboard={false}
    >
      <Modal.Header className="custom-modal-header">
        <Modal.Title className="text-capitalize fw-bold">
          {fileContent ? "Report Preview" : "Preview"}
        </Modal.Title>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={onClose}
        ></button>
      </Modal.Header>
      <Modal.Body style={{ padding: "2rem 2.5rem" }}>
        <div
          style={{
            border: '1px solid #bdbdbd',
            borderRadius: 2,
            minHeight: 420,
            background: '#fff',
            padding: 10,
            position: 'relative'
          }}
        >
          {isLoading && (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'rgba(255, 255, 255, 0.9)',
                zIndex: 1
              }}
            >
              <StethoscopeLoading message="Loading..." />
            </div>
          )}

          {error ? (
            <div className="d-flex justify-content-center align-items-center" style={{ height: 400 }}>
              <div className="text-danger">{error}</div>
            </div>
          ) : fileContent ? (
            <iframe
              src={fileContent}
              width="100%"
              height="420px"
              title="Report Preview"
              style={{
                border: 'none',
                background: '#fff',
                visibility: fileContent ? 'visible' : 'hidden'
              }}
              onLoad={handleIframeLoad}
              onError={handleIframeError}
            />
          ) : imageContent ? (
            <img
              src={imageContent}
              alt="Image Preview"
              style={{
                width: '100%',
                height: '420px',
                objectFit: 'contain',
                visibility: iframeLoaded ? 'visible' : 'hidden'
              }}
              onLoad={handleIframeLoad}
              onError={handleIframeError}
            />
          ) : (
            <div className="d-flex justify-content-center align-items-center" style={{ height: 400 }}>
              <span>No preview available</span>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button
          variant="danger"
          onClick={onClose}
          className="upload-btn-receipts ms-2"
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

ChatReportPreview.propTypes = {
  rowData: PropTypes.any,
  onClose: PropTypes.func.isRequired,
  fileContent: PropTypes.string,
  imageContent: PropTypes.string
};

export default ChatReportPreview;
